import getBaseDisplayLabel from 'sling-calendar-sdk/model-extensions/getBaseDisplayLabel';
import getShiftDisplayLabels from 'sling-calendar-sdk/model-extensions/getShiftDisplayLabels';
import * as constants from 'sling-calendar-sdk/constants';
import getEmptyProjectedSale from 'sling-calendar-sdk/process/getEmptyProjectedSale';
import getProjectedSales from 'sling-calendar-sdk/process/getProjectedSales';
import getEventDays from 'sling-calendar-sdk/process/getEventDays';
import getSchemaFields from 'sling-calendar-sdk/process/getSchemaFields';
import tallyAggregates from 'sling-calendar-sdk/process/tallyAggregates';
import context from 'sling-calendar-sdk/context';
import * as utils from 'sling-calendar-sdk/utils';
import * as timesheetsUtils from 'sling-calendar-sdk/helpers/timesheetsUtils';
import * as unavailabilityUtils from 'sling-calendar-sdk/helpers/unavailabilityUtils';
import * as timeOffUtils from 'sling-calendar-sdk/helpers/timeOffsUtils';
import canSeeUserShifts from 'sling-calendar-sdk/process/canSeeUserShifts';
import WebSocketService from 'sling-calendar-sdk/WebSocketService';
import extendUserModel from 'sling-calendar-sdk/model-extensions/extendUserModel';
import index from 'sling-calendar-sdk/process/index';
import extendCalendarModel from 'sling-calendar-sdk/model-extensions/extendCalendarModel';
import extendShiftModel from 'sling-calendar-sdk/model-extensions/extendShiftModel';
import extendLeaveModel from 'sling-calendar-sdk/model-extensions/extendLeaveModel';
import extendAvailabilityModel from 'sling-calendar-sdk/model-extensions/extendAvailabilityModel';
import extendDayMarkModel from 'sling-calendar-sdk/model-extensions/extendDayMarkModel';
import extendTagModel from 'sling-calendar-sdk/model-extensions/extendTagModel';
import CalendarCache from 'sling-calendar-sdk/CalendarCache';
import preliminaryFilterEvents from 'sling-calendar-sdk/process/preliminaryFilterEvents';
import isEventVisibleWithinDates from 'sling-calendar-sdk/process/isEventVisibleWithinDates';
import isFromForeignGroup from 'sling-calendar-sdk/process/isFromForeignGroup';
import getTotalBreakMinutes from 'sling-calendar-sdk/model-extensions/getTotalBreakMinutes';
import getShiftDurationMinutes from 'sling-calendar-sdk/model-extensions/getShiftDurationMinutes';
import getUserFullname from 'sling-calendar-sdk/model-extensions/getUserFullname';
import localize from 'sling-calendar-sdk/localize';
import getShiftAppearanceToDisplay from 'sling-calendar-sdk/helpers/getShiftAppearanceToDisplay';
import SlingApi from 'sling-calendar-sdk/SlingApi';
import isAbsenceEvent from 'sling-calendar-sdk/helpers/isAbsenceEvent';
import countries from 'sling-calendar-sdk/countries';
import TaskTemplatesCollection from 'sling-calendar-sdk/models/TaskTemplatesCollection';
import TaskInstancesCollection from 'sling-calendar-sdk/models/TaskInstancesCollection';
import TaskTemplatesCache from 'sling-calendar-sdk/models/TaskTemplatesCache';
import belongsToDayPart from 'sling-calendar-sdk/process/belongsToDayPart';
import filterOutputByModeAndDate from 'sling-calendar-sdk/process/filterOutputByModeAndDate';
import getEventTypes from 'sling-calendar-sdk/process/getEventTypes';
import * as shiftTasksActionHelpers from 'sling-calendar-sdk/helpers/shiftTasks/actionHelpers';
import * as reactionsConstants from 'sling-calendar-sdk/helpers/reactions/constants';
import * as reactionsUtils from 'sling-calendar-sdk/helpers/reactions/reactionsUtils';
import * as shiftAcceptanceUtils from 'sling-calendar-sdk/helpers/shiftAcceptance/shiftAcceptanceUtils';
import getInitialModel from 'sling-calendar-sdk/helpers/shiftAlarms/getInitialModel';
import buildSections from 'sling-calendar-sdk/helpers/shiftTasks/buildSections';
import canInteractWithTaskInstance from 'sling-calendar-sdk/helpers/shiftTasks/canInteractWithTaskInstance';
import canInteractWithSubtasks from 'sling-calendar-sdk/helpers/shiftTasks/canInteractWithSubtasks';
import * as shiftStatusUtils from 'sling-calendar-sdk/helpers/shifts/shiftStatusUtils';
import canDeleteConversation from 'sling-calendar-sdk/helpers/canDeleteConversation';
import canDeleteMessage from 'sling-calendar-sdk/helpers/canDeleteMessage';
// shift swap shared logic
import getAvailableUsers from 'sling-calendar-sdk/helpers/shiftSwap/getAvailableUsers';
import groupByLocationAndPosition from 'sling-calendar-sdk/helpers/shiftSwap/groupByLocationAndPosition';
import * as descriptionHelpers from 'sling-calendar-sdk/helpers/shiftSwap/descriptionHelpers';

export default sdk;

function sdk(path) {
  if (!(path in sdk._map)) {
    throw new Error(`Unknown sdk path: ${path}`);
  }

  return sdk._map[path];
}

sdk._map = {
  /* eslint-disable */
  'model-extensions/getBaseDisplayLabel': getBaseDisplayLabel,
  'model-extensions/getShiftDisplayLabels': getShiftDisplayLabels,
  constants: constants,
  'process/getEmptyProjectedSale': getEmptyProjectedSale,
  'process/getProjectedSales': getProjectedSales,
  'process/getEventDays': getEventDays,
  'process/getSchemaFields': getSchemaFields,
  'process/tallyAggregates': tallyAggregates,
  'process/belongsToDayPart': belongsToDayPart,
  'process/filterOutputByModeAndDate': filterOutputByModeAndDate,
  'process/getEventTypes': getEventTypes,
  context: context,
  utils: utils,
  timesheetsUtils: timesheetsUtils,
  unavailabilityUtils: unavailabilityUtils,
  timeOffsUtils: timeOffUtils,
  'process/canSeeUserShifts': canSeeUserShifts,
  WebSocketService: WebSocketService,
  'model-extensions/extendUserModel': extendUserModel,
  'process/index': index,
  'model-extensions/extendCalendarModel': extendCalendarModel,
  'model-extensions/extendShiftModel': extendShiftModel,
  'model-extensions/extendLeaveModel': extendLeaveModel,
  'model-extensions/extendAvailabilityModel': extendAvailabilityModel,
  'model-extensions/extendDayMarkModel': extendDayMarkModel,
  'model-extensions/extendTagModel': extendTagModel,
  CalendarCache: CalendarCache,
  'process/preliminaryFilterEvents': preliminaryFilterEvents,
  'process/isEventVisibleWithinDates': isEventVisibleWithinDates,
  'process/isFromForeignGroup': isFromForeignGroup,
  'model-extensions/getTotalBreakMinutes': getTotalBreakMinutes,
  'model-extensions/getShiftDurationMinutes': getShiftDurationMinutes,
  'model-extensions/getUserFullname': getUserFullname,
  localize: localize,
  getAvailableUsers: getAvailableUsers,
  groupByLocationAndPosition: groupByLocationAndPosition,
  descriptionHelpers: descriptionHelpers,
  'helpers/getShiftAppearanceToDisplay': getShiftAppearanceToDisplay,
  SlingApi: SlingApi,
  'helpers/isAbsenceEvent': isAbsenceEvent,
  countries: countries,
  'models/TaskTemplatesCollection': TaskTemplatesCollection,
  'models/TaskInstancesCollection': TaskInstancesCollection,
  'models/TaskTemplatesCache': TaskTemplatesCache,
  shiftTasksActionHelpers: shiftTasksActionHelpers,
  'helpers/shiftTasks/buildSections': buildSections,
  'reactions/constants': reactionsConstants,
  'reactions/utils': reactionsUtils,
  'helpers/shiftAlarms/getInitialModel': getInitialModel,
  'helpers/shiftTasks/canInteractWithTaskInstance': canInteractWithTaskInstance,
  'helpers/shiftTasks/canInteractWithSubtasks': canInteractWithSubtasks,
  'helpers/shifts/shiftStatusUtils': shiftStatusUtils,
  'helpers/canDeleteConversation': canDeleteConversation,
  'helpers/shiftAcceptanceUtils': shiftAcceptanceUtils,
  'helpers/canDeleteMessage': canDeleteMessage,
  /* eslint-enable */
};
